import { Chip as ChipMaterial, withStyles } from '@material-ui/core';
import clsx from 'clsx';
import React from 'react';
import useStyles from './ChipStyles';
var CustomChipMaterial = withStyles(function () { return ({
    root: {},
    label: {
        fontFamily: 'var(--main-font)',
        fontSize: '.875rem',
    },
    clickable: {},
    outlined: {
        border: '1px solid var(--secundario-gris-azulado)',
        '&:hover': {
            background: 'var(--secundario-gris-azulado)',
            color: 'var(--text1)',
        },
        '&:focus:not(:focus-visible)': {
            background: 'var(--blanco)',
            color: 'var(--text2)',
        },
        '$clickable&:hover, $clickable&:focus:not(:focus-visible)': {
            backgroundColor: 'var(--blanco)',
        },
        '&:focus-visible': {
            background: 'var(--secundario-gris-azulado)',
            color: 'var(--text1)',
        },
        '$clickable&:hover, $clickable&:focus-visible': {
            backgroundColor: 'var(--secundario-gris-azulado)',
        },
    },
}); })(ChipMaterial);
var Chip = function (_a) {
    var _b;
    var className = _a.className, label = _a.label, isActive = _a.isActive, onClick = _a.onClick;
    var styles = useStyles();
    return (React.createElement(CustomChipMaterial, { className: clsx(className, (_b = {},
            _b[styles.active] = isActive,
            _b)), label: label, onClick: onClick, variant: "outlined" }));
};
Chip.defaultProps = {
    className: '',
    isActive: false,
};
export default Chip;
